import { useQuery } from "react-query";
import axios from "axios";
import { format } from "date-fns";
import { BessChartResponse } from "./BessChartTypes";

// Endpoints do main-api (via gateway /main -> /api/bess). O header Email/Bearer
// é injetado automaticamente pelo AxiosInterceptor.
const socUrl = (equipmentId: number, date: Date) =>
    `api/bess/${equipmentId}/soc?date=${format(date, "yyyy-MM-dd")}`;

const powerUrl = (equipmentId: number, date: Date) =>
    `api/bess/${equipmentId}/power?date=${format(date, "yyyy-MM-dd")}`;

const fetchData = async (url: string): Promise<BessChartResponse> => {
    return await axios.get<BessChartResponse>(url, { timeout: 30000 }).then((res) => res.data);
};

export const useBessSoc = (equipmentId: number, date: Date) => {
    return useQuery({
        queryKey: ["bess-soc", equipmentId, format(date, "yyyy-MM-dd")],
        queryFn: () => fetchData(socUrl(equipmentId, date)),
        enabled: Boolean(equipmentId) && Boolean(date),
    });
};

export const useBessPower = (equipmentId: number, date: Date) => {
    return useQuery({
        queryKey: ["bess-power", equipmentId, format(date, "yyyy-MM-dd")],
        queryFn: () => fetchData(powerUrl(equipmentId, date)),
        enabled: Boolean(equipmentId) && Boolean(date),
    });
};
